import src from "IMAGE";
export default { src, width: 1470, height: 596, blurWidth: 8, blurHeight: 3, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAADCAYAAACuyE5IAAAAJklEQVR42oXKsQkAAAgDwew/sYJJxF7x4LtHRHqS5A38QBVN8hwabWFfaFqSPd8AAAAASUVORK5CYII="};
